__turbopack_context__.v({
  "card": "_53iKEG_card",
  "cards": "_53iKEG_cards",
  "explanation": "_53iKEG_explanation",
  "factor": "_53iKEG_factor",
  "factorIcon": "_53iKEG_factorIcon",
  "factorList": "_53iKEG_factorList",
  "factors": "_53iKEG_factors",
  "label": "_53iKEG_label",
  "links": "_53iKEG_links",
  "namePlaceholder": "_53iKEG_namePlaceholder",
  "notLegal": "_53iKEG_notLegal",
  "note": "_53iKEG_note",
  "panel": "_53iKEG_panel",
  "pending": "_53iKEG_pending",
  "placeholders": "_53iKEG_placeholders",
  "section": "_53iKEG_section",
  "settled": "_53iKEG_settled",
  "tag": "_53iKEG_tag",
  "tagDescription": "_53iKEG_tagDescription",
  "tagName": "_53iKEG_tagName",
  "tagRange": "_53iKEG_tagRange",
  "tagValue": "_53iKEG_tagValue",
});
